import type { ScoringProfile } from '../../../lib/profiles';
import { getServiceColor } from '../shapes/aws-icon-registry';

/**
 * Topology profile — the default structural view.
 *
 * No scoring rules fire. Nodes render with their service-colored accent
 * (via the shape manifest) and edges keep their category colors. This is
 * the "what is there" view — load-bearing for simple inventory exploration
 * without any compliance/risk overlay.
 */
export const TopologyProfile: ScoringProfile = {
  id: 'network-topology',
  name: 'Topology',
  description: 'Structural layout showing how resources are connected. No scoring — use this view to understand what exists and how it fits together.',
  domain: 'network',
  default: true,
  scoring: [],
  palette: {
    // Fallback colors in case a shape manifest doesn't have an accent
    server: getServiceColor('ec2'),
    relational_database: getServiceColor('rds'),
    object_storage: getServiceColor('s3'),
    function_service: getServiceColor('lambda'),
    load_balancer: getServiceColor('alb'),
    network_boundary: getServiceColor('vpc'),
    subnet: getServiceColor('subnet'),
  },
};
